import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListWeightAnimals from './ListWeightAnimals.js';
import { ListButton, AddButton, UploadButton, DownloadButton, FAB } from '../../shared/ActionButtons';
import WeightLotDropdown from '../lots/WeightLotDropdown.js';
import { API_BASE, authHeaders } from '../../utils/Utils.js';
import DateInput from '../../shared/inputs/DateInput.js';
import ErrorMessage from '../../shared/ErrorMessage.js';
import '../lots/WeightLots.css';

export const WeightAnimalsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton     isActive={screen === 'list'}   onClick={() => setScreen('list')} />
    <AddButton      isActive={screen === 'add'}    onClick={() => setScreen('add')} />
    <UploadButton   isActive={screen === 'upload'} onClick={() => setScreen('upload')} />
    <DownloadButton collection="weights" />
  </div>
);

const localDateStr = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};

const EnrollAndWeighForm = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [tag,           setTag]           = useState('');
  const [weight,        setWeight]        = useState('');
  const [date,          setDate]          = useState(localDateStr());
  const [lotId,         setLotId]         = useState('');
  const [showLotPicker, setShowLotPicker] = useState(false);
  const [error,         setError]         = useState('');
  const [saving,        setSaving]        = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const weightNum = Number(weight);
    const lotNum    = showLotPicker ? Number(lotId) : 0; // 0 = let backend resolve default
    if (!tag.trim()) { setError(t('tag_and_lot_required')); return; }
    if (showLotPicker && !lotNum) { setError(t('tag_and_lot_required')); return; }
    setSaving(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/api/weight/entry`, {
        method: 'POST', headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ tag: tag.trim(), weight: weightNum, date, lot_id: lotNum }),
      });
      if (!res.ok) { setError(t('error_saving')); setSaving(false); return; }
      onSuccess();
    } catch {
      setError(t('error_saving'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="DataCollectionAdd" onSubmit={handleSubmit}>
      <input type="text" placeholder={t('tag_number_placeholder')} value={tag}
        onChange={e => setTag(e.target.value)} required />
      <input type="number" placeholder={t('weight_kg')} value={weight}
        onChange={e => setWeight(e.target.value)} min="1" max="2000" />
      <DateInput value={date} onChange={setDate} required />

      <button type="button" className="wl-lot-toggle-btn"
        onClick={() => { setShowLotPicker(v => !v); setLotId(''); }}>
        {showLotPicker
          ? `↩ ${t('use_default_lot')}`
          : `+ ${t('add_to_specific_lot')}`}
      </button>

      {showLotPicker && (
        <WeightLotDropdown selected={lotId} onChange={e => setLotId(e.target.value)} name="lot_id" />
      )}

      <button type="submit" disabled={saving}>{saving ? '…' : t('add_button')}</button>
      <ErrorMessage message={error} />
    </form>
  );
};

export const WeightAnimals = ({ initialLotFilter, screen, setScreen, actions }) => {
  const [localScreen, setLocalScreen] = useState('list');

  const currentScreen    = screen    !== undefined ? screen    : localScreen;
  const setCurrentScreen = setScreen !== undefined ? setScreen : setLocalScreen;

  return (
    <>
      {actions && <div className="content-header">{actions}</div>}
      {currentScreen === 'list' && (
        <>
          <ListWeightAnimals initialLotFilter={initialLotFilter} />
          <FAB onClick={() => setCurrentScreen('add')} />
        </>
      )}
      {currentScreen === 'add' && (
        <EnrollAndWeighForm onSuccess={() => setCurrentScreen('list')} />
      )}
    </>
  );
};

export default WeightAnimals;
